import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const NAV: Array<{ to: string; label: string; roles?: Array<'admin' | 'reviewer' | 'dock_manager' | 'viewer'> }> = [
  { to: '/admin/dashboard', label: 'Dashboard' },
  { to: '/admin/responses', label: 'Responses' },
  { to: '/admin/inbox',     label: 'Reviewer Inbox', roles: ['admin', 'reviewer'] },
  { to: '/admin/members',   label: 'Members' },
  { to: '/admin/users',     label: 'Users', roles: ['admin'] },
];

export function AdminLayout(): JSX.Element {
  const auth = useAuth();
  if (auth.status !== 'authenticated') return <></>;

  const visibleNav = NAV.filter((item) => !item.roles || item.roles.includes(auth.user.role));

  return (
    <div className="flex h-screen bg-gray-50 text-gray-900">
      <aside className="hidden md:flex md:flex-col w-56 border-r border-gray-200 bg-white">
        <div className="px-5 py-4 border-b border-gray-200 flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0">
            <img src="/fbc-logo.png" alt="Freedom Boat Club" className="w-9 h-9 object-contain" />
          </div>
          <div>
            <div className="text-base font-semibold" style={{ fontFamily: '"Libre Baskerville", Georgia, serif', color: '#14395E' }}>FBC XM</div>
            <div className="text-xs text-gray-500">Experience management</div>
          </div>
        </div>
        <nav className="flex-1 py-2">
          {visibleNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `block px-5 py-2 text-sm ${isActive ? 'bg-blue-50 text-blue-700 font-medium border-r-2 border-blue-600' : 'text-gray-700 hover:bg-gray-50'}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-5 py-3 border-t border-gray-200 text-xs text-gray-600">
          <div className="font-medium text-gray-900 truncate">{auth.user.email}</div>
          <div className="text-gray-500 mb-2">{auth.user.role}</div>
          <button
            type="button"
            onClick={() => void auth.logout()}
            className="text-blue-600 hover:underline"
          >
            Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
